import React from 'react';
import { Link } from 'react-router-dom';
import { MdCheckCircle, MdShowChart, MdAccountBalanceWallet, MdGavel } from 'react-icons/md';
import styles from "./GestaoContabil.module.css";
import img1 from "./img/img1.png";
import img2 from "./img/img2.png";


function GestaoContabil() {
return (
    <div className={styles.paginaGestao}>
      <section className={styles.bannerGestao}>
        <div className={styles.bannerOverlay}>
          <div className={styles.bannerConteudo}>
            <h1>Gestão Contábil</h1>
            <p>Conjunto de diretrizes e práticas fundamentais para a estruturação, registro, análise e controle financeiro corporativo, visando a segurança e a sustentabilidade do negócio.</p>
            <Link to="/contato" className={`${styles.btnLink} ${styles.btnCyan}`}>Entre em Contato</Link>
          </div>
        </div>
      </section>
      <section className={`${styles.secaoGestao} ${styles.bgBranco}`}>
        <div className={styles.containerGrid}>
          
          <div className={styles.textos}>
            <h2 className={styles.tituloSecao}>Compreendendo a Gestão Contábil</h2>
            <h3 className={styles.subtituloAzul}>Saúde Financeira e Conformidade Regulatória</h3>
            <p>A gestão contábil consiste no conjunto de procedimentos metodológicos aplicados para estruturar, documentar, avaliar e administrar os recursos financeiros de uma corporação. Trata-se do mecanismo pelo qual a organização monitora rigorosamente seu fluxo de caixa e evolução patrimonial.</p>
            <p>Esse processo assegura não apenas a viabilidade financeira da empresa, mas também sua estrita adequação à legislação tributária e societária vigente.</p>
            
            <div className={styles.destaqueIdeia}>
              <strong>Síntese Operacional:</strong>
              <p>Consiste na administração estratégica dos ativos corporativos, fundamentada em dados contábeis consolidados para embasar a tomada de decisão executiva.</p>
            </div>
          </div>

          <div className={styles.imagemWrapper}>
            <img 
              src={img1} 
              alt="Análise de dados contábeis" 
              className={styles.imagemEspaco} 
            />
          </div>

        </div>
      </section>
      <section className={`${styles.secaoGestao} ${styles.bgClaro}`}>
        <div className={`${styles.containerGrid} ${styles.gridInvertido}`}>
          
          <div className={styles.imagemWrapper}>
            <img 
              src={img2}
              alt="Organização de documentos e relatórios" 
              className={styles.imagemEspaco} 
            />
          </div>

          <div className={styles.textos}>
            <h2 className={styles.tituloSecao}>Escopo de Atuação</h2>
            <p>Nossa metodologia abrange os pilares fundamentais da operação financeira corporativa:</p>
            
            <ul className={styles.listaGestao}>
              <li>
                <MdCheckCircle className={styles.iconeCheck} />
                <span><strong>Registro de Movimentações:</strong> Controle rigoroso do fluxo de receitas e despesas operacionais, integrado à emissão de documentos fiscais.</span>
              </li>
              <li>
                <MdCheckCircle className={styles.iconeCheck} />
                <span><strong>Gestão Documental:</strong> Arquivamento e controle sistemático de notas fiscais, recibos, contratos e conciliações bancárias.</span>
              </li>
              <li>
                <MdCheckCircle className={styles.iconeCheck} />
                <span><strong>Apuração Tributária:</strong> Cálculo preciso de obrigações fiscais e transmissão das declarações acessórias aos órgãos competentes.</span>
              </li>
              <li>
                <MdCheckCircle className={styles.iconeCheck} />
                <span><strong>Relatórios Gerenciais:</strong> Elaboração e análise de Demonstrativos de Resultado do Exercício (DRE), Balanços Patrimoniais e projeções de Fluxo de Caixa.</span>
              </li>
              <li>
                <MdCheckCircle className={styles.iconeCheck} />
                <span><strong>Inteligência de Negócios:</strong> Avaliação de performance financeira para otimização de custos e planejamento estratégico de expansão.</span>
              </li>
            </ul>
          </div>

        </div>
      </section>
      <section className={`${styles.secaoGestao} ${styles.bgBranco}`}>
        <div className={styles.containerGrid}>
          
          <div className={styles.textos}>
            <h2 className={styles.tituloSecao}>Objetivos Estratégicos</h2>
            <h3 className={styles.subtituloAzul}>Vantagens Competitivas para a Corporação</h3>
            <p>Uma contabilidade com viés estratégico transcende o mero cumprimento de obrigações tributárias, atuando como o núcleo de inteligência que fornece à alta gestão uma visão clara e objetiva do cenário corporativo.</p>
            <p>A implementação de uma Gestão Contábil eficiente proporciona previsibilidade orçamentária, mitigação de riscos jurídicos e o fornecimento de métricas confiáveis para a escalabilidade operacional.</p>
            <Link to="/contato" className={`${styles.btnLink} ${styles.btnAzul}`} style={{marginTop: '1rem'}}>
              Otimize sua Gestão Corporativa
            </Link>
          </div>

          <div className={styles.gridBeneficios}>
            <div className={styles.cardBeneficio}>
              <MdGavel className={styles.iconeCard} />
              <h4>Mitigação de Riscos Fiscais</h4>
              <p>Prevenção de passivos tributários e garantia de conformidade junto aos órgãos fiscalizadores.</p>
            </div>
            <div className={styles.cardBeneficio}>
              <MdShowChart className={styles.iconeCard} />
              <h4>Análise de Rentabilidade</h4>
              <p>Aferição precisa das margens de lucro e da viabilidade financeira do modelo de negócio.</p>
            </div>
            <div className={styles.cardBeneficio}>
              <MdAccountBalanceWallet className={styles.iconeCard} />
              <h4>Planejamento de Investimentos</h4>
              <p>Embasamento analítico para direcionamento de capital e mitigação de riscos em novas aplicações.</p>
            </div>
            <div className={styles.cardBeneficio}>
              <MdCheckCircle className={styles.iconeCard} />
              <h4>Eficiência Operacional</h4>
              <p>Maximização da alocação de recursos e aprimoramento contínuo dos processos internos.</p>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
} 

export default GestaoContabil;